


































































import { defineComponent, ref, computed } from 'vue-demi';
import EditNameInput from './EditNameInput.vue';
import { useI18n } from 'common-module/src/util/useI18n';
import { useInstance } from 'common-module/src/util/useInstance';
import { deleteRecorder, updateRecorder, getVideoRealPath } from '@/api/recorder';
import { createLoadingEvent, downloadOfUrl } from '@zk/framework-vue';
import VideoPlayer from 'common-module/src/components/video/VideoPlayer.vue';
export default defineComponent({
  name: 'RecordSuccessComponent',
  components: {
    EditNameInput,
    VideoPlayer
  },
  props: {
    videoName: {
      type: String,
      default: null
    },
    videoCode: {
      type: String,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    },
    fileId: {
      type: Number,
      default: null
    },
    id: {
      type: Number,
      default: null
    }
  },
  setup(props, { emit }) {

    const videoNameInputValue = ref(props.videoName);
    let transFormVideoUrl = '';

    const { t } = useI18n();

    const instance = useInstance();

    const linkUrl = computed(
      () => {
        if (!props.fileId) {
          return '';
        }
        return instance.$config.getResourceUrl('VUE_APP_PMS_URL', `/work/view-recorder?code=${props.fileId}`);
      }
    );

    async function getVideoUrl(fileKey: string, originUrl: string) {
      try {
        const url = await getVideoRealPath({ fileKey });
        return url || originUrl;
      } catch (error) {
        console.log(error);
        return originUrl;
      }
    }

    const onDelete = ref(createLoadingEvent(async () => {
      const msg = t('recorder.files.deleteConfirm.msg', {
        name: videoNameInputValue.value
      });
      const title = t('recorder.files.deleteConfirm.title');
      await instance.$msgbox.confirm(msg, title, {
        confirmButtonText: t('button.delete'),
        confirmButtonClass: 'el-button--danger'
      });
      await deleteRecorder(props.id);
      instance.$message.success(t('message.deleteSuccess'));
      emit('recorder:delete');
      instance.eventBus.$emit('recorder:delete', props.id);
    }));

    const onCopyLink = () => {
      instance.$message.success(t('message.copySuccess'));
      instance.$track.send('Copy_VideoLink', { Copy_Path: '视频预览弹窗' }, true);
    };

    const onDownload = ref(createLoadingEvent(async () => {
      let url = transFormVideoUrl || props.videoUrl;
      if (url.endsWith('.webm')) {
        url = await getVideoUrl(props.videoCode, props.videoUrl);
        // if (url === props.videoUrl) {
        //   instance.$message.warning(t('recorderPreview.downloadWaitTip'));
        //   return;
        // }
        transFormVideoUrl = url;
      }
      downloadOfUrl(url, videoNameInputValue);
    }));

    const onUpdateName = async (name: string) => {
      if (!name) {
        return;
      }
      try {
        videoNameInputValue.value = name;
        await updateRecorder(props.fileId, { videoName: name });
        emit('recorder:nameUpdate', videoNameInputValue);
      } catch (error) {
        videoNameInputValue.value = props.videoName;
      }
    };

    return {
      t,
      videoNameInputValue,
      linkUrl,
      onDelete,
      onCopyLink,
      onDownload,
      onUpdateName
    };

  }
});
